export const getGoogleAPILanguageCode = () =>
  document.documentElement.lang.substring(0, 2)
